export const NeetmockFaq = [
    {
        targetId: '1',
        heading: '1. What is Aakash All India NEET Mock Test 2026?',
        subheading: 'Aakash NEET Mock Test 2026 is an offline practice test designed for NEET (UG) 2026 aspirants to evaluate their preparation. Structured as per the official NEET pattern, it covers Physics, Chemistry, Botany, & Zoology. Students will be provided an All India Rank (AIR) along with a predicted NEET rank to benchmark performance against national benchmarks.',
        bulletpoints: [],
    },
    {
        targetId: '2',
        heading: '2. Who can participate in the Aakash All India NEET Mock Test 2026?',
        subheading: 'Any NEET 2026 aspirant can register and appear for the mock test.',
        bulletpoints: [],
    },
    {
        targetId: '3',
        heading: '3. How can I register for the NEET Mock Test 2026?',
        subheading: 'Students can register for the NEET Mock Test at their nearest Aakash Centre or through the official link: https://neet-mocktest.aakash.ac.in/mock-neet-exam. Upon completing the required details and registration process, they will receive further communication regarding the TEST.',
        bulletpoints: [],
    },
    {
        targetId: '4',
        heading: '4. Will the Aakash All India NEET Mock Test 2026 be Online or Offline?',
        subheading: `The Aakash NEET Mock Tests will be conducted in offline mode. Students are required to appear at the Aakash centre selected during the registration process.`,
        bulletpoints: [],
    },
    {
        targetId: '5',
        heading: '5. Is there any registration fee for the Aakash All India NEET Mock Test 2026?',
        subheading: 'The fee for NEET Mock Test 2026 is ₹ 99',
        bulletpoints: [],
    },
    {
        targetId: '6',
        heading: "6. What is the exam date and time slot for the Aakash All India NEET Mock Test 2026?",
        subheading: '<strong>Students can refer to the table below to check the complete details on the NEET Mock test schedule:</strong><table style="border:1px solid #ddd;margint-top:30px;"><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Type</strong></td><td style="padding: 0px 10px 0px 10px;">Mock Test for NEET 2026</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Test Mode</strong></td><td style="padding: 0px 10px 0px 10px;">Offline</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Day</strong></td><td style="padding: 0px 10px 0px 10px;">26th April 2026</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Timings</strong></td><td style="padding: 0px 10px 0px 10px;">02:00 PM – 05:00 PM</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Duration</strong></td><td style="padding: 0px 10px 0px 10px;">3 hrs</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Fees</strong></td><td style="padding: 0px 10px 0px 10px;">₹ 99</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Last Date/Time for Enrollment</strong></td><td style="padding: 0px 10px 0px 10px;">April, 25th 2026</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Admit Card Release Date</strong></td><td style="padding: 0px 10px 0px 10px;">1 Days before Exam Date</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Result Declaration</strong></td><td style="padding: 0px 10px 0px 10px;">April 29th, 2026</td></tr></table>',
        bulletpoints: [],
    },
    {
        targetId: '7',
        heading: '7. When will the admit card be released for the Aakash All India NEET Mock Test 2026?',
        subheading: 'Aakash All India NEET Mock Test 2026 Admit Card will be released 1 Days before the Exam Date',
        bulletpoints: [],
    },
    {
        targetId: '8',
        heading: '8. When will the result be declared for the Aakash All India NEET Mock Test 2026?',
        subheading: `The result will be announced 2 days after the exam date (tentative). This information is usually communicated through official announcements, notifications or the Aakash Institute's website.`,
        bulletpoints: [],
    },
    {
        targetId: '9',
        heading: '9. What are the benefits of the Aakash All India NEET Mock Test 2026?',
        subheading: 'Key Benefits of Aakash All India NEET Mock Test 2026:',
        bulletpoints: [
            {
                point: 'Simulates a real NEET TEST environment.'
            },
            {
                point: 'Provides an AAKASH All India Rank (AIR) for national-level benchmarking.'
            },
            {
                point: 'Offers a predicted NEET rank for performance estimation.'
            },
            {
                point: 'Identifies subject-wise strengths and areas for improvement in Physics, Chemistry, Botany, and Zoology.'
            },
            {
                point: 'Delivers detailed performance analysis to optimize the test strategy.'
            },
            {
                point: 'Enables practice through structured sample test papers before the final TEST.'
            }
        ],
    },
]